import { PrimarySmBtn } from '@/Buttons/PrimarySmBtn';
import styled from '@emotion/styled';
import { SkipNavLink } from '@reach/skip-nav';
import '@reach/skip-nav/styles.css';
import { Link } from 'gatsby';
import { px } from './GlobalStyles';
import { MobNav } from './MobNav';
import { DesktopNavLinks, siteInfo } from './NavLinks';
import logo from '../../../assets/images/layout/nav/logo.png';

const Header = styled.header`
    ${px};
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 16px 16px 0;
    max-width: 1920px;
    margin: 0 auto;
    z-index: 100;
    position: absolute;
    top: 0;
    left: 0;
    right: 0;

    @media (min-width: 1360px) {
        padding-left: 48px;
        padding-right: 48px;
    }

    @media (min-width: 1600px) {
        padding-left: 64px;
        padding-right: 64px;
    }
`;

const StyledLink = styled(Link)`
    transition: opacity 0.3s ease-in-out;

    :hover,
    :focus {
        opacity: 0.75;
    }

    @media (max-width: 400px) {
        > img {
            width: 225px;
            height: 45px;
        }
    }
`;

const DesktopNav = styled.nav`
    display: none;

    @media (min-width: 1024px) {
        display: flex;
        justify-content: space-between;
        width: calc(100% - 320px);
        max-width: 640px;
    }

    @media (min-width: 1600px) {
        max-width: 740px;
    }
`;

const Buttons = styled.div`
    display: none;
    align-items: center;
    gap: 24px;

    > a:first-of-type {
        transition: opacity 0.3s ease-in-out;
        display: none;
        color: ${({ theme }) => theme.white};
        font-weight: 700;

        :hover,
        :focus {
            opacity: 0.75;
        }
    }

    @media (min-width: 1144px) {
        display: flex;

        > a:first-of-type {
            display: block;
        }

        > a:last-of-type {
            display: none;
        }
    }

    @media (min-width: 1360px) {
        > a:last-of-type {
            display: flex;
        }
    }
`;

export const Nav = () => {
    return (
        <Header>
            <StyledLink to="/">
                <img src={logo} alt="integrate institute" width={275} height={55} loading="eager" />
            </StyledLink>
            <SkipNavLink />
            <MobNav />

            <DesktopNav>{DesktopNavLinks}</DesktopNav>

            <Buttons>
                <Link to="/freebies/">Freebies</Link>
                <PrimarySmBtn as="a" href={siteInfo.phone.link}>
                    {siteInfo.phone.text}
                </PrimarySmBtn>
            </Buttons>
        </Header>
    );
};
